module.exports = __webpack_public_path__ + "img/iosInstallScreen.e8bdc291.svg";